import { registerActions } from "../actionRegistry";
import { toastSuccess } from "../ui/messages";
import { modal } from "../ui/modal";
import { api } from "../api";
import { getDomElement } from "../utils/dom";
import { open_modal_what, openModalCount } from "../globalState";

export async function deleteuser(id: string): Promise<void> {
  if (!confirm("Are you sure you want to delete this user?")) return;
  try {
    await api.users.delete({ id: Number(id) });
    toastSuccess("User deleted");
    const size = getDomElement("partnerdetails") ? "large" : "dynamic";
    modal(open_modal_what[openModalCount] ?? "", size, 1);
  } catch (err: unknown) {
    alert((err as Error).message);
  }
}

export async function addfeaturedartist(user_id: string): Promise<void> {
  try {
    await api.artists.addFeatured({ id: Number(user_id) });
    toastSuccess("Featured artist added");
  } catch (err: unknown) {
    alert((err as Error).message);
  }
}

export function captchaFinished(token: string): void {
  const captchaEl = getDomElement<HTMLInputElement>("signup-captcha");
  if (captchaEl) captchaEl.value = token;
}

/*
 * `firstquestions()` used to live here: it read eight `q{n}_{yes,no}` radios plus
 * `q5_val`, wrote the answers into five hidden `#q1`…`#q5` inputs in `Chrome.tsx`,
 * and routed to `signup:step3`.
 *
 * `FirstQuestionsModal.tsx` replaced all of it — it holds the four answers and the
 * sales figure in `useState` and encodes them into the modal key
 * (`signup:step3:q1:q2:q3:q4:q5`), which `SignupModal` decodes via `parseSurvey`.
 * Nothing dispatched the old function: `"firstquestions"` in `viewContract.ts` is
 * a MODAL key, not a VIEW_ACTION, so the `registerActions` entry was its only
 * reference and the hidden inputs its only readers. Both are gone.
 *
 * ⚠️ The two encodings differ — the old one wrote yes/no as 1/2, the modal writes
 * 1/0. See `todo/signup-flow-followups.md`; historic `ArtistProfile.survey_q*`
 * rows span both eras.
 */

registerActions({
  captchaFinished,
});
